export const SLICE_NAME: string = 'globalToast';
